import { takeLatest } from 'redux-saga/effects';
import { onGetAllEntries } from './effects';

export const getAllEntriesSaga = function* () {
    yield takeLatest('entries/GET_ENTRIES', onGetAllEntries);
}

export default [getAllEntriesSaga];